import React, { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import SupportWidget from "./SupportWidget";
import WhatsAppButton from "./WhatsAppButton";
import ExitIntentModal from "./ExitIntentModal";
import ScrollToTopButton from "./ScrollToTopButton";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function Layout({ children }) {
  const [maintenance, setMaintenance] = useState(false);

  useEffect(() => {
    fetch(`${BACKEND}/health`, { credentials: "include" })
      .then((r) => r.json())
      .then((d) => { if (d.maintenance) setMaintenance(true); })
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-eduhu-bg text-eduhu-ink">
      {maintenance && (
        <div
          data-testid="maintenance-banner"
          className="w-full bg-amber-400 text-amber-950 text-sm text-center py-2.5 px-4 font-medium"
        >
          EDUHUB is currently under scheduled maintenance. We'll be back shortly.
        </div>
      )}
      <Header />
      <main id="main-content" role="main" className="flex-1">{children}</main>
      <Footer />
      <SupportWidget />
      <WhatsAppButton />
      <ScrollToTopButton />
      <ExitIntentModal />
    </div>
  );
}
